export const formatPhone = (phone) => {
    const phone1 = phone.replace(/\D+/g,"");
    if (phone1.length < 9) {
        return phone;
    }
    return `(${phone1.substring(0,3)}) ${phone1.substring(3,6)}-${phone1.substring(6)}`;
};